import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ghosts-elements',
  templateUrl: './ghosts-elements.component.html',
  styleUrls: ['./ghosts-elements.component.scss']
})
export class GhostsElementsComponent implements OnInit {
  @Input() nbElements: number[];
  constructor() {}

  ngOnInit() {}
}
